import React, { useCallback, useState } from 'react';
import AddCircle from './add-circle/AddCircle';

import '../../../style/Common.css';
import '../../../style/Sidebar.css';

const EditorSidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = useCallback(() => setIsSidebarOpen(!isSidebarOpen), [isSidebarOpen]);

  return (
    <div>
      <div className={`sidebar ${isSidebarOpen ? 'openedSidebar' : 'closedSidebar'}`}>
        <div className="sidebar-inner text-left">
          <AddCircle />

          <div className="latch" onClick={toggleSidebar}>
            <span className="arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth="1.25"
                  d="M7 3.17L4.88 5.3a1 1 0 0 0 0 1.42L7 8.83"
                ></path>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorSidebar;
